import React, { useState, useEffect } from 'react'
import { getRequest, postRequest } from '../../globalhelper/helper'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Alert
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import axios from 'axios'
import ApiConstants from '../../config'
import ArticleIcon from '@mui/icons-material/Article'
import { connect } from 'react-redux'
import moment from 'moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const BillExtract_Search = ({ login, ...props }) => {
  const [state, setState] = useState({
    formData: {
      vendorname: '',
      orgname: '',
      billnumber: '',
      billdate: null
    },
    showtable: false,
    tableData: [],
    dropdown_vendorname: [],
    dropdown_orgname: [],
    dropdown_billnumber: [],
    companyDetails: [],
    error: false,
    errorMessage: '',
    redirect: false,
    SearchJSON: [],
    DialogBox: null
  })

  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search Bill Extract');
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = _.sortBy(response?.res?.data, 'orgname');
      const arr = responseData?.map(item => item.orgname)?.sort((a, b) => a.localeCompare(b));
      setState(prev => ({
        ...prev,
        dropdown_orgname: arr,
        companyDetails: responseData
      }));
    }).catch(err => console.log(err));
  }, []);
  useEffect(() => {
    if (state.dropdown_orgname.length === 1) {
      handleChange('orgname', state.dropdown_orgname[0]);
    }
  }, [state.companyDetails]);
  const handleRemainingValues = value => {
    const companyDetail = state.companyDetails.find(item => item.orgname === value);
    if (companyDetail) {
      getRequest(`api/edureka/billExtractInfo?orgid=${companyDetail.orgid}`).then(res => {
        if (res.res.status === 'success') {
          const temp = JSON.parse(res.res.data);
          const vendornameOptions = temp
            .map(value => value['Vendor Name'])
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b));

          const billnumberOptions = temp
            .map(val => val.documentnumber)
            .filter(Boolean)
            .sort((a, b) => a.localeCompare(b));
          setState(prev => ({
            ...prev,
            dropdown_vendorname: [...new Set(vendornameOptions)],
            dropdown_billnumber: [...new Set(billnumberOptions)]
          }));
        }
      }).catch(err => console.log(err));
    }
  };
  const handleChange = (name, value) => {
    console.log("handleChange", name, value);
    setState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        [name]: value
      }
    }));
    if (name === 'orgname' && value !== null) {
      console.log("Calling handleRemainingValues");
      handleRemainingValues(value);
    }
  };
  const handleReset = () => {
    setState(prev => ({
      ...prev,
      showtable: false,
      tableData: [],
      error: false,
      errorMessage: '',
      formData: {
        vendorname: '',
        orgname: '',
        billnumber: '',
        billdate: null
      }
    }));
  };
  const handleSearch = () => {
    if (!state.formData.orgname) {
      setState(prev => ({
        ...prev,
        error: true,
        errorMessage: 'Please select all the required fields'
      }));
      return;
    }
    const {
      vendorname,
      billnumber,
      billdate
    } = state.formData;

    const formattedBillDate = billdate
      ? moment(billdate).format('YYYY-MM-DD')
      : '';
    const companyDetail = state.companyDetails.find(item => item.orgname === state.formData.orgname);
    if (companyDetail) {
      const request = {
        name: vendorname,
        orgid: companyDetail.orgid,
        billnumber: billnumber,
        billdate: formattedBillDate
      };
      postRequest(`api/edureka/getBillExtractSearchData`, request).then(res => {
        const temp = JSON.parse(res.res.data);
        setState(prev => ({
          ...prev,
          tableData: temp,
          showtable: !!temp.length,
          error: !temp.length,
          errorMessage: temp.length ? '' : 'No data found. Please try some other combination'
        }));
      }).catch(err => console.log(err));
    }
  };
  const handleBill = i => {
    const billid = i['Bill Number'];
    const companyDetail = state.companyDetails.find(item => item.orgname === state.formData.orgname);
    const orgid = companyDetail.orgid;
    if (companyDetail) {
      localStorage.setItem('api', `api/edureka/getUpdatedDataFromDB`);
      localStorage.setItem('apiParams', JSON.stringify({
        "LDE": {
          "Organization ID": orgid,
          "Bill Number": billid,
        },
        "Module": localStorage.getItem('module'),
        "screenName": "BillExtract"
      }));
      window.open(`/Dynamic_Forms?token=BillExtract&action=edit&orgId=${companyDetail.orgid}&docId=${billid}`, '_blank');
    }
  };
  const handleInterimID = i => {
    const interimid = i.interimid
    const companyDetail = state.companyDetails.find(
      item => item.orgname === state.formData.orgname
    )

    if (companyDetail) {
      localStorage.setItem('api', `api/edureka/getInterimBill?interimid=${interimid}&orgid=${companyDetail.orgid}`);
      window.open(`/Dynamic_Forms?token=BillExtract&action=edit&orgId=${companyDetail.orgid}&docId=${interimid}`, '_blank');
    }
  }

  const getPOasDocument = async item => {
    try {
      console.log('Calling Bill API', item)

      const id = state.companyDetails.filter(
        item => item.orgname === state.formData.orgname
      )

      const companyid = id.map(item => item.orgid)

      let response = await axios.post(
        ApiConstants.externals.serverUrl + `api/edureka/getBillAsDocument`,
        {
          filename: item['Bill Number'],
          vendorEmailID: item['Vendor EmailID'],
          VendorID: item['Vendor ID'],
          tenantid: login?.userData?.USR_Tenant || '',
          orgid: companyid[0],
          orgname: state.formData.orgname
        },
        {
          responseType: 'blob'
        }
      )

      console.log(response)

      if (response) {
        let fileURL = URL.createObjectURL(response.data)

        setState(prev => ({
          ...prev,
          DialogBox: (
            <Dialog
              open={true}
              onClose={() =>
                setState(prev => ({
                  ...prev,
                  DialogBox: null
                }))
              }
              fullWidth
              maxWidth='lg'
            >
              <DialogContent sx={{ p: 2 }}>
                <Box sx={{ height: '500px' }}>
                  <iframe
                    src={fileURL}
                    title='pdf-viewer'
                    style={{
                      width: '100%',
                      height: '100%'
                    }}
                  />
                </Box>
              </DialogContent>
            </Dialog>
          )
        }))
      }
    } catch (error) {
      console.log('Bill PDF Error:', error)
    }
  }

  const onBack = () => {
    setState(prev => ({
      ...prev,
      redirect: false,
      SearchJSON: []
    }));
  };
  if (state.redirect) {
    return <VR2_Forms screenName={'BillExtract'} screenAction={'edit'} From_SearchJSON={state.SearchJSON} onBack={onBack} />;
  }

  return (
    <>
      {state.DialogBox}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>Search Bill</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xl={2}>
              <Autocomplete options={state.dropdown_orgname} value={state.formData.orgname} onChange={(e, newValue) => handleChange('orgname', newValue)} renderInput={params => <TextField {...params} label='Organization Name' variant='outlined' size='small' style={{
                width: 200
              }} />} />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete options={state.dropdown_vendorname} value={state.formData.vendorname} onChange={(e, newValue) => handleChange('vendorname', newValue)} renderInput={params => <TextField {...params} label='Vendor Name' variant='outlined' size='small' style={{
                width: 200
              }} />} />
            </Grid>
            <Grid item xl={2}>
              <Autocomplete options={state.dropdown_billnumber} value={state.formData.billnumber} onChange={(e, newValue) => handleChange('billnumber', newValue)} renderInput={params => <TextField {...params} label='Bill Number' variant='outlined' size='small' style={{
                width: 200
              }} />} />
            </Grid>
            <Grid item xl={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="Bill Date"
                  value={state.formData.billdate}
                  onChange={(newValue) =>
                    handleChange('billdate', newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      style={{ width: 200 }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xl={1}>
              <Button variant='contained' color='success' onClick={handleSearch}>
                Search
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button variant='contained' color='error' onClick={handleReset}>
                Reset
              </Button>
            </Grid>
            <Grid item xl={1}>
              <Button variant='contained' color='warning' onClick={() => props.onBack()}>
                Back
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <br />

      {state.showtable && state.tableData.length > 0 && (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Bill Number</TableCell>
                <TableCell>Interim ID</TableCell>
                <TableCell>Vendor ID</TableCell>
                <TableCell>Vendor Name</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Show Document</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {state.tableData
                .sort((a, b) =>
                  a['Bill Number'].localeCompare(b['Bill Number'])
                )
                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Button
                        size='small'
                        variant='text'
                        color='primary'
                        disabled={item.Status === 'Rejected'}
                        onClick={() => handleBill(item)}
                      >
                        {item['Bill Number']}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        size='small'
                        variant='text'
                        color='primary'
                        disabled={
                          item.Status === 'Active' ||
                          item.Status === 'Waiting For Approval'
                        }
                        onClick={() => handleInterimID(item)}
                      >
                        {item.interimid}
                      </Button>
                    </TableCell>
                    <TableCell>{item['Vendor ID']}</TableCell>
                    <TableCell>{item['Vendor Name']}</TableCell>
                    <TableCell>{item['Date']}</TableCell>
                    <TableCell>{item['Status']}</TableCell>
                    <TableCell>
                      <IconButton
                        color='primary'
                        onClick={() => getPOasDocument(item)}
                      >
                        <ArticleIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {state.error && <div className='center-screen'>{state.errorMessage}</div>}
    </>
  )
}

const mapStateToProps = state => ({
  login: state.login
})

export default connect(mapStateToProps)(BillExtract_Search)